<template>
  <div>
    <div v-if="get_absen_loading || get_staff_loading || loading" class="loading-container">
      <div class="loader"></div>
    </div>
    <div v-if="!get_absen_loading">
      <div>
        <div class="flex justify-between items-center border-b border-gray-100 px-5 pt-3 pb-3 m-0">
          <div class="flex-grow">
            <p class="playfair-display-400 text-base p-0 m-0">Jadwal WFA / WFH / FWA</p> 
          </div>
          <div>
            <el-date-picker v-model="tanggal" type="date" size="mini" placeholder="Tanggal"></el-date-picker>
          </div>
          <!-- <div class="ml-0.5">
            <el-button icon="el-icon-search" size="mini" @click="search_by_date" circle></el-button>
          </div> -->
          <!-- <div class="ml-0.5">
            <el-button icon="el-icon-refresh" size="mini" @click="refresh_by_date" circle></el-button>
          </div> -->
          <div class="ml-0.5">
            <el-button icon="el-icon-plus" size="mini" @click="open_dialogvisible"  circle></el-button>
          </div>
        </div>
      </div>
      <div>
        <div v-for="(item, index) in get_wfh" :key="index">
          <div class="flex justify-between items-center border-b border-gray-100 hover:bg-gray-50 cursor-pointer px-5 pt-2.5 pb-2.5 m-0" v-if="by_tanggal === item.tanggal">
            <div class="flex-grow">             
              <p class="text-base text-left roboto-regular leading-normal p-0 m-0">{{ item.username }}</p>
              <p class="text-gray-600 text-xs text-left roboto-mono-300 p-0 m-0">{{ item.nip | format_nip }}</p>
            </div>
            <div>
              <p class="text-xs text-left roboto-light p-0 m-0">{{ item?.tanggal | konversi_tanggal }}</p>
            </div>

          </div>
        </div> 
      </div>
    </div>
    <el-dialog title="Input Jadwal WFH / WFA / FWA" :visible.sync="dialogvisible" width="50%">
      <div>
        <!-- <div>
          <input type="file" @change="handleFileUpload" />
        </div> -->
        <div class="flex justify-start items-center">
          <div class="flex-grow mr-1">
            <el-select v-model="form.nip" placeholder="Pilih Nama" style="width:100%;" filterable>
              <el-option v-for="item in get_all_staff" :key="item.nip" :label="item.username" :value="item.nip"></el-option>
              <!-- <el-option v-for="item in get_staff" :key="item.nip" :label="item.username" :value="item.nip"></el-option> -->
            </el-select>
          </div>
          <div>
            <el-date-picker v-model="tanggal_wfh_wfa" type="date" placeholder="Tanggal" style="width:10rem;"></el-date-picker>
          </div>
          <div class="ml-1">
            <el-button type="info" @click="tambah_jadwal" :disabled="form.nip == null">Tambah</el-button>
          </div>
        </div>
        <div class="mt-6" v-if="jadwal.length > 0">
          <!-- {{ jadwal }} -->
          <div v-for="(item, index) in jadwal" :key="index">
            <div class="flex justify-between items-center border-b border-gray-100 hover:bg-gray-50 cursor-pointer px-5 pt-2.5 pb-2.5 m-0">
              <!-- <div class="flex-grow ml-3">
                <p class="text-lg text-left roboto-light p-0 m-0" v-for="sample in get_staff" :key="sample.nip"><span v-if="sample.nip == item.nip">{{ sample.username }}</span></p>
                <p class="roboto-mono-300 p-0 m-0">{{ item.nip }}</p>
              </div> -->
              <div class="flex-grow ml-3">
                <p class="text-base text-left roboto-regular leading-normal p-0 m-0" v-for="sample in all_employe" :key="sample.nip"><span v-if="sample.nip == item.nip">{{ sample.username }}</span></p>
                <p class="text-gray-600 text-xs text-left roboto-mono-300 p-0 m-0">{{ item.nip }}</p>
              </div> 
              <div>
                <p class="text-sm text-right titillium-web-regular p-0 m-0">{{ item.tanggal | konversi_tanggal }}</p>
                <!-- <p class="text-gray-500 text-sm text-right roboto-light p-0 m-0">{{ item.username }}@lan.go.id</p> -->
              </div>
              <div class="ml-2">
                <p class="text-xl text-red-600 cursor-pointer hover:text-red-500 p-0 m-0" @click="hapus_jadwal(index)"><i class="el-icon-circle-close"></i></p>
              </div>
            </div>
          </div>
        </div>
        <!-- {{ jadwal }} -->
        <!-- {{ get_staff }} -->
        <!-- {{ get_all_staff }} -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogvisible = false">Cancel</el-button>
        <el-button size="mini" type="primary" :disabled="jadwal.length == 0" :loading="loading"  @click="submit_dialogvisible">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import readXlsxFile from 'read-excel-file';
import all_employe from '../../assets/json/employee.json'; 
export default {
  data() {
    return {
      tanggal: moment().format("YYYY-MM-DD"),
      today: moment(new Date()).format("YYYY-MM-DD"),
      tanggal_wfh_wfa: new Date(),
      now: new Date(),
      loading: false,
      dialogvisible: false,
      absen: {},
      form: {nip: null, nama: null, username: null, pegawai: {}},
      jadwal: [], 
      all_employe: all_employe.records
    }
  },
  filters: {
    konversi_tanggal: function(value){
      moment.locale('id'); 
      return moment(value).format('dddd')+', '+moment(value).format('LL');
    },
    konversi_waktu: function(value){
      moment.locale('id'); 
      return value === null ? 'Belum Absen' : moment(value).format('HH.mm');
    },
    format_output: function(value) {
      if (value != null) {
        let abc = value.split("@");
        return abc[0];
      }
      return "Belum ada";
    },
    format_evidence: function(value) {
      if (value != null) {
        let abc = value.split("@");
        return abc[1];
      }
      return "Belum ada";
    },
    format_nip: function(value) {
      return value.substring(0, 8)+" "+value.substring(8, 14)+" "+value.substring(14, 15)+" "+value.substring(15, 18);
    },
  },
  computed: {
    get_absen() {
      return this.$store.state.absen.absen
    },
    get_staff() {
      return this.$store.state.staff.staff 
    },
    get_all_staff() {
      return this.$store.state.staff.all_staff
    },
    get_wfh() {
      return this.$store.state.wfh.wfh
    },
    get_all() {
      return this.$store.state.wfh.all
    },
    get_absen_loading() {
      return this.$store.state.absen.loading
    },
    get_staff_loading() {
      return this.$store.state.staff.loading
    },
    get_wfh_loading() {
      return this.$store.state.wfh.loading
    },
    by_tanggal(){
      return moment(this.tanggal).format("YYYY-MM-DD")
    }
  },
  created() {
    this.$store.dispatch('absen/get_rekapan', {tanggal: this.tanggal})
    this.$store.dispatch('staff/get_staff')
    this.$store.dispatch('staff/get_all_staff')
    this.$store.dispatch('wfh/get_jadwal_wfh_or_wfa')
    // this.$store.dispatch('wfh/get_all_jadwal_wfh_or_wfa')
  },
  methods: {
    search_by_date: function() {
      this.loading = true;
      this.$store.dispatch('absen/get_rekapan', {tanggal: this.tanggal})
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false; 
      })
    },
    refresh_by_date: function() {
      this.loading = true;
      this.$store.dispatch('absen/get_rekapan', {tanggal: this.today})
      .then(() => {
        this.loading = false;
        this.tanggal = moment(new Date()).format("YYYY-MM-DD");
        this.today = moment(new Date()).format("YYYY-MM-DD");
      })
      .catch(() => {
        this.loading = false; 
      })
    },
    open_dialogvisible: function() {
      this.dialogvisible = true;
      this.jadwal = [];
      this.form.nip = null;
      this.form.nama = null;
      this.form.username = null;
      this.form.pegawai = {};
      // console.log(value);
    },
    objectExists: function(array, obj) {
      return array.some(item => item.nip === obj.nip && item.tanggal === obj.tanggal);
    },
    findUniqueEntries: function(listA, listB) {
      return listB.filter(itemB => 
        !listA.some(itemA => itemA.nip === itemB.nip && itemA.tanggal === itemB.tanggal)
      );
    },
    tambah_jadwal: function() {
      let tanggal_wfh_wfa_convert = moment(this.tanggal_wfh_wfa).format("YYYY-MM-DD");

      if (!this.objectExists(this.jadwal, {nip: this.form.nip, tanggal: tanggal_wfh_wfa_convert}) && !this.objectExists(this.get_wfh, {nip: this.form.nip, tanggal: tanggal_wfh_wfa_convert})) {
        this.jadwal.push({nip: this.form.nip, tanggal: tanggal_wfh_wfa_convert});
        this.form.nip = null;
      }
    },
    hapus_jadwal: function(index) {
      this.jadwal.splice(index, 1);
    },
    convert_arr_obj_1: function(value) {
      // Initialize an object to group by tanggal
      const grouped = {};

      // Iterate through the input array
      value.forEach(item => {
        const { tanggal, nip } = item;

        // If the tanggal doesn't exist in the grouped object, create it
        if (!grouped[tanggal]) {
          grouped[tanggal] = { tanggal, nip: [] };
        }

        // Push the nip into the nip array
        grouped[tanggal].nip.push({ penerima: nip });
      });

      const result = Object.values(grouped);

      return result;
    },
    convert_arr_obj_2: function(value) {
      // Initialize an array to hold the result
      const result = [];

      // Iterate through the input array
      value.forEach(item => {
        const { tanggal, nip } = item;

        // Iterate through the nip array
        nip.forEach(nipItem => {
          // Push a new object with tanggal and nip into the result array
          result.push({tanggal: tanggal, nip: nipItem.penerima});
        });
      });

      return result;
    },
    convert_arr_obj_1_2: function(value) {
      // Initialize an object to group by date
      const grouped = {};

      // Iterate through the input array
      value.forEach(item => {
        const nip = item[1]; // Get the nip value
        const date = item[3]; // Get the date value

        // Format the date to "YYYY-MM-DD"
        const formattedDate = date.toISOString().split('T')[0];

        // If the date doesn't exist in the grouped object, create it
        if (!grouped[formattedDate]) {
            grouped[formattedDate] = { tanggal: formattedDate, nip: [] };
        }

          // Push the nip into the nip array
          grouped[formattedDate].nip.push({ penerima: nip });
      });

      const result = Object.values(grouped);

      return result; 
    },
    convert_arr_obj_2_2: function(value) {
      // Initialize an array to hold the result
      const result = [];

      // Iterate through the input array
      value.forEach(item => {
        const nip = item[1]; // Get the nip value
        const date = item[3]; // Get the date value

        // Format the date to "YYYY-MM-DD"
        const formattedDate = date.toISOString().split('T')[0];

        // Push the new object into the result array
        result.push({
          tanggal: formattedDate,
          nip: nip
        });
      });

      // Log the result
      return result; 
    },
    submit_dialogvisible: function() {
      // this.jadwal = [];
      // this.form.nip = null;
      // this.form.nama = null;
      // this.form.username = null;
      // this.form.pegawai = {};

      let data_jadwal = this.jadwal;

      this.loading = true;

      // console.log(this.jadwal);

      // const result = {
      //   tanggal: this.jadwal[0].tanggal, 
      //   nip: []
      // };

      // this.jadwal.forEach(item => {
      //   result.nip.push({ penerima: item.nip });
      // });

      // console.log(result);

      // for (let i = 0; i < data_jadwal.length; i++) {
        // const element = data_jadwal[i];
        // this.$store.dispatch("wfh/post_jadwal_wfh_or_wfa",result)
        // .then(() => {
        //   this.loading = false;
        //   this.dialogvisible = false;
        //   this.$store.dispatch('wfh/get_jadwal_wfh_or_wfa')
        // });
      // }

      let result = this.convert_arr_obj_1(data_jadwal);
      
      // console.log(result);

      for (let i = 0; i < result.length; i++) {
        const element = result[i];
        this.$store.dispatch("wfh/post_jadwal_wfh_or_wfa", element)
        .then(() => {
          this.loading = false;
          this.dialogvisible = false;
          this.$store.dispatch('wfh/get_jadwal_wfh_or_wfa')
        });
      }
      
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      readXlsxFile(file).then((rows) => {
        console.log(rows);

        // this.jadwal = [];
        let data_jadwal_wfh_wfa_fwa = []
        for (let i = 1; i < rows.length; i++) {
          const element = rows[i];
          data_jadwal_wfh_wfa_fwa.push(element);
        }

        let result = this.convert_arr_obj_2_2(data_jadwal_wfh_wfa_fwa);

        let uniqueEntries = this.findUniqueEntries(result, this.get_wfh)

        this.jadwal = result;
        
        // console.log(result);

        // console.log(uniqueEntries);
        
      });
    },
    hapus_jadwal_wfh_wfa_fwa: function(value) {
      this.loading = true;
      this.$store.dispatch('wfh/delete_jadwal_wfh_or_wfa', {id: value})
      .then(() => {
        this.loading = false;
        this.$store.dispatch('wfh/get_jadwal_wfh_or_wfa')
      })
      .catch(() => {
        this.loading = false;
      })
      // console.log(value); 
    }
  },
}
</script>